import React from "react";

// series: [{period, ebitda}], oldest -> newest. Renders an 18-month bar sparkline.
export default function Sparkline({ series, testid }) {
  if (!series || series.length < 2) return <span className="text-[#94A7AE]">&mdash;</span>;
  const vals = series.map((d) => d.ebitda);
  const min = Math.min(...vals, 0);
  const max = Math.max(...vals);
  const range = max - min || 1;
  const w = 92, h = 30, n = vals.length;
  const gap = 3;
  const bw = (w - gap * (n - 1)) / n;
  const up = vals[vals.length - 1] >= vals[0];
  const color = up ? "#0D9488" : "#E11D48";

  return (
    <svg width={w} height={h} data-testid={testid} className="block">
      {vals.map((v, i) => {
        const bh = Math.max(2, ((v - min) / range) * (h - 4));
        return (
          <rect
            key={series[i].period}
            x={i * (bw + gap)}
            y={h - bh}
            width={bw}
            height={bh}
            fill={color}
            opacity={0.35 + (0.65 * (i + 1)) / n}
            rx="1"
          />
        );
      })}
    </svg>
  );
}
